<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>卡组配置</span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="卡组配置" name="first">
            <el-row :gutter="10" class="mb8" style="margin-top: 10px;">
              <el-col :span="1.5">
                <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importProbUploadSuccess(res)}" :headers="headers">
                  <el-button v-permisaction="['config:cardGroup:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
                </el-upload>
              </el-col>
              <el-col :span="1.5">
                <el-button
                  v-permisaction="['config:cardGroup:export']"
                  type="primary"
                  icon="el-icon-download"
                  size="mini"
                  @click="exportData()"
                >导出</el-button>
              </el-col>
              <el-col :span="1.5"><ClearCacheApply /><sync-data /></el-col>
              <el-button v-permisaction="['config:cardGroup:makeJson']" size="mini" type="primary" @click="makeJson">生成json</el-button>
              <syncVersion :in-method="ossSyncGroupJson" :params="params" />

              <!--              <el-button v-permisaction="['config:cardGroup:syncJson']" :loading="loading" size="mini" type="primary" @click="syncJson">同步到S3</el-button>-->
            </el-row>

            <el-table style="border:1px solid #ccc" :data="formData" border stripe>
              <el-table-column prop="cgid" label="卡组ID">
                <template v-slot:default="scope">
                  <el-input v-model.number="scope.row.cgid" />
                </template>
              </el-table-column>
              <el-table-column prop="cg_name" label="卡组名">
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.cg_name" />
                </template>
              </el-table-column>
              <el-table-column width="220px" prop="cg_lang_key" label="多语言KEY">
                <template v-slot:default="scope">
                  <el-input v-model="scope.row.cg_lang_key" />
                </template>
              </el-table-column>
              <el-table-column prop="cg_lock_rank" label="解锁等级">
                <template v-slot:default="scope">
                  <el-input v-model.number="scope.row.cg_lock_rank" />
                </template>
              </el-table-column>
              <el-table-column prop="cg_type" label="卡组类型">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.cg_type" placeholder="请选择">
                    <el-option
                      v-for="item in cgType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="cg_title_img_id" label="标题底图">
                <template v-slot:default="scope">
                  <el-input v-model.number="scope.row.cg_title_img_id" />
                </template>
              </el-table-column>
              <el-table-column prop="cg_title_img_id" label="奖励">
                <template v-slot:default="scope">
                  {{ getRewardList(scope.row.reward) }}
                </template>
              </el-table-column>
              <el-table-column prop="cg_lang_key" label="奖励配置">
                <template v-slot:default="scope">
                  <el-button type="primary" size="mini" icon="el-icon-edit" @click="langVisibleArr[scope.$index].visible = true" />
                  <el-drawer title="奖励配置" :before-close="done=>handleClose(done,scope.$index)" size="850px" :visible="langVisibleArr[scope.$index].visible">
                    <commReward v-model="scope.row.reward" />
                  </el-drawer>
                </template>
              </el-table-column>
              <el-table-column prop="cg_title_img_id" label="操作">
                <template v-slot:default="scope">
                  <el-button v-permisaction="['config:cardGroup:del']" type="danger" @click="del(scope.row.cgid, scope.$index, 'first')">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button v-permisaction="['config:cardGroup:add']" style="margin-top: 10px" type="primary" @click="onSubmit('first')">保存</el-button>
            <pagination
              v-show="total>0"
              background
              :page.sync="queryParams.pageIndex"
              :limit.sync="queryParams.pageSize"
              :total="total"
              @pagination="getTables('first')"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  delCardGroup,
  importCardGroup,
  exportCardGroup,
  getCardGroupList,
  updateCardGroup,
  ossSyncGroupJson
} from '@/api/config/card-pro'
import { getRewardType } from '@/api/config/slot'
import { getRewardListForPropsId } from '@/utils'
import commReward from '@/components/Reward/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'CardGroup',
  components: {
    SyncData,
    ClearCacheApply,
    SyncVersion,
    commReward
  },
  data() {
    return {
      loading: false,
      activeName: 'first',
      langVisibleArr: [{ visible: false }],
      langExclusiveVisibleArr: [{ visible: false }],
      total: 0,
      params: { name: 'CardConfig' },
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      rewardType: [],
      formData: [
        {
          'cgid': 0,
          'cg_name': '',
          'cg_lang_key': '',
          'cg_petFeed_reward': 0,
          'cg_petExp_reward': 0,
          'cg_title_img_id': 0,
          'cg_coin_reward': 0,
          'cg_spin_reward': 0,
          'cg_lock_rank': 0,
          'cg_type': 0,
          'cg_group': 0
        }
      ],
      formExclusiveData: [
        {
          'cgid': 0,
          'cg_name': '',
          'cg_lang_key': '',
          'cg_name_zh': '',
          'cg_name_tw': '',
          'cg_name_fr': '',
          'cg_name_de': '',
          'cg_name_es': '',
          'cg_name_pt': '',
          'cg_name_th': '',
          'cg_name_vn': '',
          'cg_name_no': '',
          'cg_name_id': '',
          'cg_avatar': '',
          'cg_level': 0,
          'cg_group': 0
        }
      ],
      skinId: [62, 19],
      cgType: [{ label: '常规卡组', value: 0 }, { label: '限时卡组', value: 1 }],
      chessId: [],
      areaId: [],
      tsType: [
        {
          'value': 1,
          'label': '限时'
        },
        {
          'value': 0,
          'label': '不限时'
        }
      ],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ]
    }
  },
  created() {
    this.getRewardTypeData()
    this.getTables('first')
  },
  methods: {
    ossSyncGroupJson,
    handleClose(done, index) {
      this.langVisibleArr[index].visible = false
    },
    onSubmit(name) {
      let data = ''
      if (name === 'first') {
        data = JSON.stringify(this.formData)
      } else {
        data = JSON.stringify(this.formExclusiveData)
      }

      console.log(data)
      updateCardGroup({ data: data, name: name }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(tableName) {
      getCardGroupList({ name: tableName }).then(res => {
        res.data.forEach((item, index) => {
          if (tableName === 'first') {
            this.langVisibleArr.push({
              visible: false
            })
            this.formData = res.data
          } else {
            this.langExclusiveVisibleArr.push({
              visible: false
            })
            this.formExclusiveData = res.data
          }
        })
      })
    },
    add(name) {
      if (name === 'first') {
        this.formData.push({
          'cgid': 0,
          'cg_name': '',
          'cg_lang_key': '',
          'cg_name_zh': '',
          'cg_name_tw': '',
          'cg_name_fr': '',
          'cg_name_de': '',
          'cg_name_es': '',
          'cg_name_pt': '',
          'cg_name_th': '',
          'cg_name_vn': '',
          'cg_name_no': '',
          'cg_name_id': '',
          'cg_petFeed_reward': 0,
          'cg_petExp_reward': 0,
          'cg_title_img_id': 0,
          'cg_coin_reward': 0,
          'cg_spin_reward': 0,
          'cg_lock_rank': 0,
          'cg_level': 0,
          'cg_group': 0,
          reward: []
        })
        this.langVisibleArr.push({ visible: false })
      } else {
        this.formExclusiveData.push({
          'cgid': 0,
          'cg_name': '',
          'cg_lang_key': '',
          'cg_name_zh': '',
          'cg_name_tw': '',
          'cg_name_fr': '',
          'cg_name_de': '',
          'cg_name_es': '',
          'cg_name_pt': '',
          'cg_name_th': '',
          'cg_name_vn': '',
          'cg_name_no': '',
          'cg_name_id': '',
          'cg_avatar': '',
          'cg_level': 0,
          'cg_group': 0
        })
        this.langExclusiveVisibleArr.push({ visible: false })
      }
    },
    del(id, index, name) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCardGroup({ id: id, data: name }).then(res => {
            if (res.code === 200) {
              this.getTables(name)
              this.msgSuccess(res.msg)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        if (name === 'first') {
          this.formData = this.formData.filter((item, key) => {
            return index !== key
          })
        } else {
          this.formExclusiveData = this.formExclusiveData.filter((item, key) => {
            return index !== key
          })
        }
      }
    },
    exportData() {
      exportCardGroup().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response) {
      this.$refs.upload.clearFiles()
      importCardGroup({ data: response.data.path, name: name }).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables('first')
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClick(tab, event) {
      const tableName = tab.name
      this.getTables(tableName)
    },
    addReward(index) {
      this.formData[index].reward.push(
        {
          propsId: 14,
          num: 0,
          skin: '',
          rtype: 1
        }
      )
    },
    removeReward(index, i) {
      this.formData[index].reward = this.formData[index].reward.filter((item, key) => {
        return i !== key
      })
    },
    getRewardTypeData() {
      getRewardType({ data: 1 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    propChange(v, index, i) {
      const record = this.formData[index].reward[i]
      const typ = parseInt(v)
      record.num = 1
      switch (typ) {
        case 64:
          record.skin = this.chessId[0].value
          break

        case 19:
          record.skin = this.areaId[0].value
          break
        default:
          record.skin = 0
      }
      this.formData[index].reward[i] = record
    }, getRewardList(prize) {
      return getRewardListForPropsId(prize, this.rewardType)
    },
    syncJson() {
      this.$confirm('该操作将同步到S3, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        ossSyncGroupJson({ name: 'CardConfig' }).then(res => {
          this.loading = false
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    makeJson() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/makeJson')
      // makeCardGroupJson().then(res => {
      //   if (res.code === 200) {
      //     this.msgSuccess(res.msg)
      //     this.getTables()
      //   } else {
      //     this.msgError(res.msg)
      //   }
      // })
    }
  }
}
</script>

<style scoped>
</style>
